import { useState } from "react";
import { ADD_ON_CHART } from "../scheduleBuilder";

const usePlanningEvent = (openPlanningEvent) => {
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(null);

  const load = () => {
    if (event || !openPlanningEvent) return;
    setError(null);
    openPlanningEvent()
      .then(setEvent)
      .catch((e) => setError((e.response && e.response.data && e.response.data.error) || "Could not open the seating chart."));
  };

  return { event, error, load };
};

const NO_CHART = { context: null, label: "", open: undefined };

export const useChartPlanning = (charts) => {
  const [context, setContext] = useState(charts.length > 0 ? charts[0].context : null);
  const chart = charts.find((candidate) => candidate.context === context) || charts[0] || NO_CHART;
  const admission = usePlanningEvent((charts.find((candidate) => candidate.context === null) || NO_CHART).open);
  const addOn = usePlanningEvent((charts.find((candidate) => candidate.context === ADD_ON_CHART) || NO_CHART).open);

  return { chart, select: setContext, planning: chart.context === ADD_ON_CHART ? addOn : admission };
};

export default usePlanningEvent;
